<template>
	<div class="ui basic" v-if="subscriptions">
		<semantic-loading :active="showLoader" :text="$t('globals.loaders.loading')"></semantic-loading>
		<!-- Header -->
		<div class="ui">
			<div class="ui blue rounded button right floated" :class="activeMerchant && activeMerchant.opus && !$auth.user().social_number ? 'disabled' : ''" @click="showAvailableProductsModal = !showAvailableProductsModal">
				<i class="plus icon"></i>
				{{ $t('pages.dashboard.availproducts') }}
			</div>
			<h1 class="ui zw compact header">
				{{ $t('pages.dashboard.title') }}
			</h1>
		</div>

		<!-- Subscriptions menu -->
		<!-- <div class="ui divider horizontal header">
			<i class="cubes icon"></i>
			{{ $t('pages.dashboard.subscriptions.header') }}
		</div> -->
    <div class="ui tabular inverted menu subscriptions-menu" v-if="subscriptions">
      <div class="left menu subscriptions-menu-left">
        <div class="item" v-for="(subscription, index) in subscriptions.data" @click="changeSubscription(subscription.id)" :class="[{ 'active' : findActiveTab(subscription.id, index) }, statusClass]" :key="subscription.id">
          {{ subscription.product.name }}
        </div>
      </div>
      <div class="right menu subscriptions-menu-right" :style="`max-width: ${paginationWidth}`">
        <a class="icon item" v-if="showSubscriptionPrev" @click="prevSubscriptionPage"><i class="chevron left icon"></i></a>
        <div class="icon item" v-if="totalSubscriptionPages > 1">{{ currentSubscriptionPage }}</div>
        <a class="icon item" v-if="showSubscriptionNext" @click="nextSubscriptionPage"><i class="chevron right icon"></i></a>
      </div>
    </div>


    <!-- <div class="ui divider horizontal header"><i class="user icon"></i>{{ $t('pages.dashboard.details.header') }}</div> -->

		<subscription-details v-if="activeSubscription" :activeSubscription="activeSubscription" :subscriptions="subscriptions" />

		<div class="ui divider" v-if="subscriptions && activeSubscription"></div>

		<subscriptions v-if="subscriptions && activeSubscription" :subscriptions="subscriptions" :activeSubscription="activeSubscription" ></subscriptions>

		<div class="ui centered aligned icon header" v-if="nothingFound">
			<i class="close icon"></i>
			{{ $t('globals.validation.errors.nothing_found') }}
		</div>

    <modal ref="modal" :active="isCardExpired" :title="$t('modals.expired_card.title')" icons="big alarm" @acceptmodal="openCheckoutPageToUpdate">
      <h4>{{ $t('modals.expired_card.header', {firstname: this.$auth.user().firstname, surname: this.$auth.user().surname}) }}</h4>
      <span v-html="$t('modals.expired_card.body', {container: $t('globals.container.subscription'), product_name: this.subscriptionWithExpiredCard.productName})"></span>
    </modal>

    <modal ref="modal" :active="showUpdateSubscriptionNotice" :title="$t('modals.payment_system_update.title')" icons="big alarm" @acceptmodal="openCheckoutPage" @denymodal="closeUpdateModal">
      <h4>{{ $t('modals.payment_system_update.header', {firstname: this.$auth.user().firstname, surname: this.$auth.user().surname}) }}</h4>
      <span v-html="$t('modals.payment_system_update.body', {container: $t('globals.container.subscription'), product_name: this.activeSubscriptionProductName})"></span>
    </modal>

		<available-products-modal :active="showAvailableProductsModal"></available-products-modal>
	</div>
</template>

<script>
export default {
	name: 'home',

	metaInfo () {
		return {
			title: 'Dashboard'
		}
	},

	data () {
		return {
			subscriptions: null,
			activeSubscription: null,
			activeSubscriptionProductName: '',
			showNewSubscriptionModal: false,
			showUpdateSubscriptionNotice: false,
			unsetSubscription: null, // fetch the first unset subscription for this merchant.. make this better
			currentSubscriptionPage: 1,
			totalSubscriptionPages: 1,

			showAvailableProductsModal: false,
			isCardExpired: false,
			subscriptionWithExpiredCard: {}
		}
	},

	computed: {
    paginationWidth () {
      if (this.showSubscriptionPrev && this.showSubscriptionNext) {
        return '150px'
      }
      if (this.showSubscriptionNext || this.showSubscriptionPrev) {
        return '100px'
      }

      return '0px'
    },

		merchants () {
			return this.$store.getters.Merchants
		},

		activeMerchant () {
			return this.$store.getters.activeMerchant
		},

		showSubscriptionNext () {
			return this.currentSubscriptionPage < this.totalSubscriptionPages && this.totalSubscriptionPages > 1
		},

		showSubscriptionPrev () {
			return this.currentSubscriptionPage !== 1 && this.totalSubscriptionPages > 1
		},

		statusClass () {
			if (this.activeSubscription) {
				if (this.activeSubscription.status === 'active') {
					return 'blue'
				} else if (this.activeSubscription.status === 'inactive' || this.activeSubscription.status === 'overdue') {
					return 'red'
				} else if (this.activeSubscription.status === 'delayed') {
					return 'yellow'
				} else {
					return 'grey'
				}
			}
		},

		showLoader () {
			return this.activeSubscription === null && this.subscriptions.length > 0
		},

		nothingFound () {
			return this.totalSubscriptionPages === 0
		}
	},

	watch: {
		activeMerchant: function (newMerchant, oldMerchant) {
      if (newMerchant.id !== oldMerchant.id) {
        this.subscription = null
        this.activeSubscription = null
        this.unsetSubscription = null

        this.initialFetch(newMerchant.id, true)
      }
		},

    activeSubscription () {
      this.showUpdateSubscriptionNotice = false
      if (this.activeSubscription && this.activeSubscription.pricing) {
        if (!this.activeSubscription.is_free &&
          !this.activeSubscription.product.category.water_meter &&
          (this.activeSubscription.pricing.type === 'recurring' ||
            (this.activeSubscription.pricing.type === 'instant' && this.activeSubscription.status === 'delayed'))
        ) {
          if (this.activeSubscription.payment_method === 'nets') {
            const netsDetails = this.activeSubscription.nets_details
            const usesUnscheduledAgreement = this.activeSubscription.product.unscheduled ||
              (netsDetails && netsDetails.is_unscheduled)
            const agreementId = usesUnscheduledAgreement
              ? netsDetails && netsDetails.unscheduled_subscription_id
              : netsDetails && netsDetails.subscription_id

            if (!netsDetails || !netsDetails.payment_id ||
              (this.activeSubscription.pricing.type === 'recurring' && !agreementId)
            ) {
              this.showUpdateSubscriptionNotice = true
              this.activeSubscriptionProductName = this.activeSubscription.product.name
            } else {
              this.showUpdateSubscriptionNotice = false
            }
          } else if (this.activeSubscription.payment_method === 'vipps') {
            if (this.activeSubscription.status === 'active' && this.activeSubscription.pricing.type === 'recurring' && !this.activeSubscription.vipps_setup) {
              this.showUpdateSubscriptionNotice = true
              this.activeSubscriptionProductName = this.activeSubscription.product.name
            } else {
              this.showUpdateSubscriptionNotice = false
            }
          }
        }
      } else {
        this.showUpdateSubscriptionNotice = false
      }
    },

		unsetSubscription: function () {
			this.$nextTick(() => {
				if (this.unsetSubscription !== null) {
					this.showNewSubscriptionModal = !this.showNewSubscriptionModal
				}
			})
		},

		currentSubscriptionPage () {
			this.initialFetch(this.activeMerchant.id, true)
		}
	},

	mounted () {
		this.initialFetch(this.activeMerchant.id)

		this.$events.$on('updatesubscriptions', (data, isCancelling) => {
			this.initialFetch(this.activeMerchant.id, true, true, isCancelling)
		})

		this.$events.$on('updateactivesubscription', (data) => {
			this.fetchActiveSubscription(this.activeSubscription.id)
				.then(Subscription => {
					this.activeSubscription = Subscription
				})
		})
	},

	methods: {
		fetchSubscriptions (merchantid) {
			// Create logic to sort out bookings from the returned array
			return new Promise((resolve, reject) => {
				if (merchantid) {
					this.axios.get(`merchants/${merchantid}/subscriptions`, {
						params: {
							page: this.currentSubscriptionPage,
							perPage: 6,
							filter: 'active|delayed|overdue'
						}
					})
					.then(({data}) => {
						this.totalSubscriptionPages = data.last_page
						resolve(data)
					}, error => {
						reject(error)
					})
				} else {
					reject('Missing Merchant ID')
				}
			})
		},

		fetchActiveSubscription (subscriptionid) {
			return new Promise((resolve, reject) => {
				if (subscriptionid) {
					this.axios.get(`subscriptions/${subscriptionid}`)
						.then(({data}) => {
							// update route
							this.$router.push({name: 'subscriptiondashboard', params: { subscriptionId: data.id }})

							// resolve the subscription
							resolve(data)
						}, error => {
							reject(error)
						})
				} else {
					reject('Missing Subscription ID')
				}
			})
		},

		initialFetch (activeMerchantId, merchantchange = false, refreshSubscriptions = false, isCancelling = false) {
			this.fetchSubscriptions(activeMerchantId)
				.then(Subscriptions => {
					this.subscriptions = Subscriptions
					if (this.activeSubscription === null && Subscriptions.data.length > 0 || merchantchange) {
						let subscriptionId

						if (merchantchange && !refreshSubscriptions) {
							this.$router.push({name: 'dashboard'})

							if (Subscriptions.data.length > 0) {
								subscriptionId = Subscriptions.data[0].id
							}
						} else {
              if (isCancelling) {
                if (Subscriptions.data.length > 0) {
                  subscriptionId = Subscriptions.data[0].id
                }
              } else {
                subscriptionId = this.$route.params.subscriptionId ? this.$route.params.subscriptionId : Subscriptions.data[0].id

                for (let key in Subscriptions.data) {
                  let subscription = Subscriptions.data[key]
                  if (subscription && subscription.pricing) {
                    if (subscription.status === 'overdue') {
                      subscriptionId = subscription.id
                      break
                    }

                    if (!subscription.is_free && subscription.pricing.type === 'recurring' || (subscription.pricing.type === 'instant' && subscription.status === 'delayed')) {
                      if (subscription.payment_method !== 'mobile_pay') {
                        if (subscription.payment_id === null) {
                          subscriptionId = subscription.id
                          break
                        }
                      }
                    }
                  }
                }
              }
						}

            this.fetchSubscriptionsWithExpiredCard()

						this.fetchActiveSubscription(subscriptionId)
							.then(Subscription => {
                const possibleStatuses = ['active', 'delayed', 'overdue']
                if (!possibleStatuses.includes(Subscription.status)) {
                  this.$router.push({name: 'dashboard'}, () => {
                    this.$router.go()
                  })
                }
								this.activeSubscription = Subscription
							}).catch(() => {
                this.$router.push({name: 'dashboard'}, () => {
                  this.$router.go()
                })
							})
					} else {
            this.$router.replace({name: 'dashboard'})
          }
				}).catch(() => this.$router.replace({name: 'dashboard'}))
		},

		fetchSubscriptionsWithExpiredCard () {
      if (this.activeMerchant) {
        this.axios.get(`users/${this.$auth.user().id}/expiredCardSubscriptions?merchant_id=${this.$store.getters.activeMerchant.id}`)
          .then((response) => {
            if (response.status === 200) {
              this.isCardExpired = true
              this.subscriptionWithExpiredCard = response.data
            }
          })
          .catch()
      }
    },

		changeSubscription (subscriptionid) {
			if (this.activeSubscription) {
				if (subscriptionid !== this.activeSubscription.id) {
					this.activeSubscription = null

					this.fetchActiveSubscription(subscriptionid)
						.then(Subscription => {
							this.activeSubscription = Subscription
						})
				}
			} else if (subscriptionid) {
				this.activeSubscription = null

				this.fetchActiveSubscription(subscriptionid)
					.then(Subscription => {
						this.activeSubscription = Subscription
					})
			}
		},

		findActiveTab (subscriptionId, index) {
			if (this.activeSubscription) {
				return subscriptionId === this.activeSubscription.id
			} else if (index) {
				return index === 0
			}
		},

    openCheckoutPageToUpdate () {
      if (Object.keys(this.subscriptionWithExpiredCard).length > 0) {
        this.$router.push({name: 'checkout', params: { containerId: this.subscriptionWithExpiredCard.id }, query: {container: 'subscription', subscriptionId: this.subscriptionWithExpiredCard.netsSubscriptionId}})
      }
    },

    openCheckoutPage () {
      if (this.showUpdateSubscriptionNotice) {
        this.$events.$emit('close-overdue-modal')
      }

      if (!this.activeSubscription.payment_method || this.activeSubscription.payment_method === 'nets') {
        let query = {
          container: 'subscription'
        }

        if (this.activeSubscription.product.unscheduled ||
          (this.activeSubscription.nets_details && this.activeSubscription.nets_details.is_unscheduled)) {
          query.unscheduled = true
        }

        if (this.activeSubscription.status === 'overdue' &&
          this.activeSubscription.apply_overdue_fee &&
          this.activeSubscription.product.overdue_fee_amount !== null &&
          !this.activeSubscription.overdue_fee_payed) {
          query['overdue_fee'] = true
        }

        this.$router.push({name: 'checkout', params: { containerId: this.activeSubscription.id }, query: query})
      } else {
        this.createVippsMobilePayPayment()
      }
    },

    createVippsMobilePayPayment() {
      this.axios.post(`subscriptions/${this.activeSubscription.id}/createPayment`, {}).then((response) => {
        let link = null

        if (response.data.payment_method === 'vipps') {
          link = response.data.url
        }

        if (link) {
          window.location.href = link
        } else {
          this.$events.$emit('alert', {
            header: this.$t('globals.validation.errors.something_went_wrong'),
            message: this.$t('globals.validation.errors.try_again_later'),
            type: 'error',
            align: 'right'
          })
        }
      }).catch((error) => {
        if (error.response) {
          if (error.response.data.message) {
            let messageText

            if (this.isJson(error.response.data.message)) {
              let errorDescription = JSON.parse(error.response.data.message);

              if (errorDescription.hasOwnProperty('error_description')) {
                messageText = errorDescription.error_description.message
              } else if (errorDescription.hasOwnProperty('message')) {
                messageText = errorDescription.message
              } else {
                messageText = this.$t('globals.validation.errors.try_again_later')
              }
            } else {
              messageText = error.response.data.message;
            }

            this.$events.$emit('alert', {
              header: this.$t('globals.validation.errors.error'),
              message: messageText,
              type: 'error',
              align: 'right'
            })
          } else {
            this.$events.$emit('alert', {
              header: this.$t('globals.validation.errors.something_went_wrong'),
              message: this.$t('globals.validation.errors.try_again_later'),
              type: 'error',
              align: 'right'
            })
          }
        } else {
          this.$events.$emit('alert', {
            header: this.$t('globals.validation.errors.something_went_wrong'),
            message: this.$t('globals.validation.errors.try_again_later'),
            type: 'error',
            align: 'right'
          })
        }
      })
    },

    closeUpdateModal () {
      this.showUpdateSubscriptionNotice = false
    },

		refreshMetaValues (subscriptionId) {
			return new Promise((resolve, reject) => {
				if (subscriptionId) {
					this.fetchActiveSubscription(subscriptionId)
						.then(Subscription => {
							this.activeSubscription = Subscription
							resolve(Subscription)
						}, error => {
							reject(error)
						}).catch()
				} else {
					reject('Missing Subscription ID')
				}
			})
		},

		refreshUnset (subscriptionId) {
			this.fetchActiveSubscription(subscriptionId)
				.then(Subscription => {
					this.unsetSubscription.product.fields = Subscription.product.fields
					this.unsetSubscription.accessories = Subscription.accessories
					this.unsetSubscription.pricing_plans = Subscription.pricing_plans
				})
		},

		fetchUnsetSubscription () {
			this.axios.get(`merchants/${this.activeMerchant.id}/subscriptions`, {
				params: {
					page: 1,
					perPage: 1,
					filter: 'unset|activating|deletable'
				}
			})
			.then(({data}) => {
				if (data.total >= 1) {
					this.unsetSubscription = null
					this.fetchActiveSubscription(data.data[0].id)
						.then(Subscription => {
							// Manual subscriptions are activated and invoiced by the merchant
							if (!Subscription.is_manual) {
								this.unsetSubscription = Subscription
							}
						})
				}
			})
		},

		prevSubscriptionPage () {
			if (this.currentSubscriptionPage <= 1) {
				return false
			} else {
				this.currentSubscriptionPage = this.currentSubscriptionPage - 1
			}
		},

		nextSubscriptionPage () {
			if (this.currentSubscriptionPage === this.totalSubscriptionPages) {
				return false
			} else {
				this.currentSubscriptionPage === this.currentSubscriptionPage++
			}
		}
	},

	beforeDestroy () {
		this.$events.$off('updatesubscriptions')
		this.$events.$off('updateactivesubscription')
	}
}
</script>

<style lang="scss" scoped>
	.ui.inverted.menu {
		background: none;
		border-bottom: 1px solid #d4d4d5;

		.blue.active.item {
			background-color: #00a9f7 !important;
		}

    .yellow.active.item {
      background-color: #f39c12 !important;
    }

		.item:not(.active) {
			color: #000;
			background: #dadada;
			border-radius: .28571429rem .28571429rem 0 0!important;

			&:hover {
				background: #adadad
			}
		}

    &.subscriptions-menu {
      align-items: flex-end;

      @media screen and (max-width: 767px){
        flex-wrap: wrap;
      }

      .subscriptions-menu-left {
        overflow-y: hidden;
        overflow-x: auto;
        flex-grow: 1;
        height: 42px;
      }

      .subscriptions-menu-right {
        margin-top: 10px;

        @media screen and (max-width: 767px){
          margin-right: auto;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/merchant/Dashboard.vue